import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { SettingService } from 'src/app/shared/services/node-api/setting.service';

@Component({
  selector: 'app-company-sorts',
  templateUrl: './company-sorts.component.html',
  styleUrls: ['./company-sorts.component.scss'],
})
export class CompanySortsComponent implements OnInit {
  @Output() selectSortFilter: EventEmitter<any> = new EventEmitter();
  @Input() heading: any;
  plan: string;
  isAdvance: boolean;
  isPremium: boolean;
  isFree: boolean;

  sortingOptions = ["Relevance", "Brand Name(A to Z)", "Brand Name(Z to A)", "Valuation: Low-High", "Valuation: High-Low", "Revenue: Low-High", "Revenue: High-Low"];


  @Input() selectedOption = "Relevance"
  public allSelectedFilter = {
    name: null,
    lastest_revenue: null,
    total_valuation: null,
    selectedOption: "Relevance"
  };
  constructor(
    private localStorageService: LocalStorageService,
    public settingService: SettingService
  ) { }

  ngOnInit(): void {
    this.plan = this.localStorageService.getItem('plan');
    if (this.plan === 'plan_advance') {
      this.isAdvance = true;
    } else if (this.plan === 'plan_premium') {
      this.isPremium = true;
    } else {
      this.isFree = true;
    }
  }

  sortCompanyList(event: any) {
    this.selectedOption = event.target.value;
    const sortOption = event.target.value;
    this.allSelectedFilter.selectedOption = sortOption;
    switch (sortOption) {
      case 'Brand Name(A to Z)':
        this.allSelectedFilter.name = 1;
        this.selectSortFilter.emit(this.allSelectedFilter);
        break;
      case 'Brand Name(Z to A)':
        this.allSelectedFilter.name = -1;
        this.selectSortFilter.emit(this.allSelectedFilter);
        break;
      case 'Valuation: Low-High':
        this.allSelectedFilter.lastest_revenue = 1;
        this.selectSortFilter.emit(this.allSelectedFilter);
        break;
      case 'Valuation: High-Low':
        this.allSelectedFilter.lastest_revenue = -1;
        this.selectSortFilter.emit(this.allSelectedFilter);
        break;
      case 'Revenue: Low-High':
        this.allSelectedFilter.total_valuation = 1;
        this.selectSortFilter.emit(this.allSelectedFilter);
        break;
      case 'Revenue: High-Low':
        this.allSelectedFilter.total_valuation = -1;
        this.selectSortFilter.emit(this.allSelectedFilter);
        break;

      default:
        // this.allSelectedFilter.total_valuation = -1;
        this.selectSortFilter.emit(this.allSelectedFilter);
        break;
    }
  }
}
